// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__0EDR1","footer":"NavbarSimple_footer__XMnZ7","link":"NavbarSimple_link__5GZLw","linkIcon":"NavbarSimple_linkIcon__CQji3"};